import { ASSIGNEE, HIDE_FILTERED, END_TIME, SEARCH, GENERIC_CHANNEL, START_TIME, STATUS, HIDE_TRASH, VID } from '../constants/FilterKeys';
import updateAssigneeFilter from './updateAssigneeFilter';
import updateContactFilter from './updateContactFilter';
import updateSearchFilter from './updateSearchFilter';
import updateStatusFilter from './updateStatusFilter';
import updateChannelFilter from './updateChannelFilter';
import updateEndTime from './updateEndTime';
import updateStartTime from './updateStartTime';
import updateFilteredToggle from './updateFilteredToggle';
import updateTrashToggle from './updateTrashToggle';
const updateChatFiltersByFilterKey = (key, value, filters) => {
  switch (key) {
    case ASSIGNEE:
      return updateAssigneeFilter(filters, value);
    case HIDE_FILTERED:
      return updateFilteredToggle(filters, value);
    case END_TIME:
      return updateEndTime(filters, value);
    case SEARCH:
      return updateSearchFilter(filters, value);
    case GENERIC_CHANNEL:
      return updateChannelFilter(filters, value);
    case START_TIME:
      return updateStartTime(filters, value);
    case STATUS:
      return updateStatusFilter(filters, value);
    case HIDE_TRASH:
      return updateTrashToggle(filters, value);
    case VID:
      return updateContactFilter(filters, value);
    default:
      return filters;
  }
};
export default updateChatFiltersByFilterKey;